import { PortableTextReactComponents } from '@portabletext/react'
import styles from './NewsletterSignUpSection.module.scss'

export const headerSerializer: Partial<PortableTextReactComponents> = {
  types: {},
  block: {
    normal: ({ children }) => <h2 className={styles.header}>{children}</h2>,
  },
  marks: {
    strong: ({ children }) => <strong>{children}</strong>,
    em: ({ children }) => <em>{children}</em>,
    redText: ({ children }) => <span className={styles.redText}>{children}</span>,
  },
}

export const smallHeaderSerializer: Partial<PortableTextReactComponents> = {
  types: {},
  block: {
    normal: ({ children }) => <h2 className={styles.smallHeader}>{children}</h2>,
  },
}

export const subtitleSerializer: Partial<PortableTextReactComponents> = {
  types: {},
  block: {
    normal: ({ children }) => <p className={styles.subtitle}>{children}</p>,
  },
}

export const successMessageTitleSerializer: Partial<PortableTextReactComponents> = {
  types: {},
  block: {
    normal: ({ children }) => <h2 className={styles.successMessageTitle}>{children}</h2>,
  },
}

export const successMessageSubtitleSerializer: Partial<PortableTextReactComponents> = {
  types: {},
  block: {
    normal: ({ children }) => <p className={styles.successMessageSubtitle}>{children}</p>,
  },
}
